export default "__VITE_ASSET__C$P0CN4c__"